/**
 * Pick Your Favorites
 * Global State Controller
 *
 * Single source of truth for:
 * - selected bag
 * - selected candies
 * - quantities
 * - total picks
 * - pricing
 * - automatic bag discounts
 */

window.PYF = window.PYF || {};


/* =====================================================
   DEFAULT SETTINGS
===================================================== */

PYF.defaultBag = {
  id: "pyf-bag-8",
  size: "½ lb",
  maxPicks: 8,
  variantId: "48457339666677"
};

PYF.pricePerPick = 1.89;


/* =====================================================
   DISCOUNT SETTINGS
===================================================== */

/**
 * Discount rates are based on bag capacity:
 *
 * ½ lb / 8 picks  = 0%
 * 1 lb / 16 picks = 10%
 * 2 lb / 32 picks = 15%
 */
PYF.discountRates = {
  8: 0,
  16: 0.10,
  32: 0.15
};


/* =====================================================
   INITIAL STATE
===================================================== */

PYF.state = {
  bag: {
    id: PYF.defaultBag.id,
    size: PYF.defaultBag.size,
    maxPicks: PYF.defaultBag.maxPicks,
    variantId: PYF.defaultBag.variantId
  },

  items: {},

  currentPicks: 0,

  pricePerPick: PYF.pricePerPick
};


/* =====================================================
   INITIALIZE STATE
===================================================== */

PYF.initState = function() {
  if (!PYF.state) {
    PYF.state = {
      bag: {
        id: PYF.defaultBag.id,
        size: PYF.defaultBag.size,
        maxPicks: PYF.defaultBag.maxPicks,
        variantId: PYF.defaultBag.variantId
      },

      items: {},

      currentPicks: 0,

      pricePerPick: PYF.pricePerPick
    };
  }

  if (!PYF.state.bag) {
    PYF.state.bag = {
      id: PYF.defaultBag.id,
      size: PYF.defaultBag.size,
      maxPicks: PYF.defaultBag.maxPicks,
      variantId: PYF.defaultBag.variantId
    };
  }

  if (!PYF.state.items) {
    PYF.state.items = {};
  }

  PYF.state.currentPicks =
    Number(PYF.state.currentPicks) || 0;

  PYF.state.pricePerPick =
    Number(PYF.state.pricePerPick) ||
    PYF.pricePerPick;

  console.log(
    "🍬 PYF State Initialized"
  );

  return PYF.state;
};


/* =====================================================
   STATE EVENT
===================================================== */

PYF.emitStateChange = function(reason) {
  document.dispatchEvent(
    new CustomEvent(
      "pyf:state-changed",
      {
        detail: {
          reason:
            reason ||
            "state-updated",

          state:
            PYF.state
        }
      }
    )
  );
};


/* =====================================================
   RESET SELECTED CANDIES
===================================================== */

PYF.resetItems = function(
  emitChange = true
) {
  PYF.state.items = {};

  PYF.state.currentPicks = 0;

  if (emitChange) {
    PYF.emitStateChange(
      "items-reset"
    );
  }
};


/* =====================================================
   RESET COMPLETE BUILDER
===================================================== */

PYF.resetBuilder = function() {
  PYF.state.bag = {
    id: PYF.defaultBag.id,
    size: PYF.defaultBag.size,
    maxPicks:
      PYF.defaultBag.maxPicks,
    variantId:
      PYF.defaultBag.variantId
  };

  PYF.state.items = {};

  PYF.state.currentPicks = 0;

  PYF.state.pricePerPick =
    PYF.pricePerPick;

  PYF.emitStateChange(
    "builder-reset"
  );
};


/* =====================================================
   SELECT BAG
===================================================== */

PYF.setBag = function(
  bagOrSize,
  maxPicks,
  variantId,
  bagId
) {
  let nextBag;

  if (
    bagOrSize &&
    typeof bagOrSize === "object" &&
    !Array.isArray(bagOrSize)
  ) {
    nextBag = {
      id:
        bagOrSize.id ||
        bagOrSize.bagId ||
        `pyf-bag-${
          Number(
            bagOrSize.maxPicks
          ) || 8
        }`,

      size:
        bagOrSize.size ||
        bagOrSize.label ||
        "½ lb",

      maxPicks:
        Number(
          bagOrSize.maxPicks
        ) || 8,

      variantId:
        bagOrSize.variantId
          ? String(
              bagOrSize.variantId
            )
          : null
    };
  } else {
    nextBag = {
      id:
        bagId ||
        `pyf-bag-${
          Number(maxPicks) || 8
        }`,

      size:
        String(
          bagOrSize || "½ lb"
        ),

      maxPicks:
        Number(maxPicks) || 8,

      variantId:
        variantId
          ? String(variantId)
          : null
    };
  }

  const currentBag =
    PYF.state.bag;

  const bagChanged =
    currentBag.id !==
      nextBag.id ||
    currentBag.size !==
      nextBag.size ||
    currentBag.maxPicks !==
      nextBag.maxPicks ||
    currentBag.variantId !==
      nextBag.variantId;

  PYF.state.bag =
    nextBag;

  /*
   * Changing bag size clears the
   * currently selected candy mix.
   */
  if (bagChanged) {
    PYF.state.items = {};

    PYF.state.currentPicks = 0;
  }

  PYF.emitStateChange(
    bagChanged
      ? "bag-changed"
      : "bag-reselected"
  );

  return PYF.state.bag;
};


/* =====================================================
   GET ITEM
===================================================== */

PYF.getItem = function(productId) {
  const key =
    String(productId);

  return (
    PYF.state.items[key] ||
    null
  );
};


/* =====================================================
   GET ITEM QUANTITY
===================================================== */

PYF.getItemQuantity = function(
  productId
) {
  const item =
    PYF.getItem(productId);

  if (!item) {
    return 0;
  }

  return (
    Number(item.quantity) || 0
  );
};


/* =====================================================
   ADD ITEM
===================================================== */

PYF.addItem = function(
  productOrId,
  image,
  title,
  variantId
) {
  if (PYF.isBagFull()) {
    PYF.emitStateChange(
      "bag-full"
    );

    return {
      success: false,
      reason: "bag-full"
    };
  }

  let product;

  if (
    productOrId &&
    typeof productOrId === "object" &&
    !Array.isArray(productOrId)
  ) {
    product = {
      productId:
        productOrId.productId ||
        productOrId.id ||
        productOrId.variantId,

      variantId:
        productOrId.variantId ||
        productOrId.productId ||
        productOrId.id,

      title:
        productOrId.title ||
        productOrId.name ||
        "Candy",

      image:
        productOrId.image ||
        ""
    };
  } else {
    product = {
      productId:
        productOrId,

      variantId:
        variantId ||
        productOrId,

      title:
        title ||
        "Candy",

      image:
        image ||
        ""
    };
  }

  if (!product.productId) {
    console.error(
      "PYF.addItem: Missing product ID.",
      product
    );

    return {
      success: false,
      reason:
        "missing-product-id"
    };
  }

  const key =
    String(
      product.productId
    );

  if (!PYF.state.items[key]) {
    PYF.state.items[key] = {
      productId:
        key,

      variantId:
        product.variantId
          ? String(
              product.variantId
            )
          : key,

      title:
        String(
          product.title ||
          "Candy"
        ),

      image:
        String(
          product.image ||
          ""
        ),

      quantity:
        0
    };
  }

  PYF.state.items[
    key
  ].quantity += 1;

  PYF.state.currentPicks += 1;

  PYF.emitStateChange(
    "item-added"
  );

  return {
    success: true,
    item:
      PYF.state.items[key]
  };
};


/* =====================================================
   REMOVE ITEM
===================================================== */

PYF.removeItem = function(
  productId
) {
  const key =
    String(productId);

  const item =
    PYF.state.items[key];

  if (
    !item ||
    item.quantity <= 0
  ) {
    return {
      success: false,
      reason:
        "item-not-found"
    };
  }

  item.quantity -= 1;

  PYF.state.currentPicks =
    Math.max(
      0,
      PYF.state.currentPicks - 1
    );

  if (item.quantity <= 0) {
    delete PYF.state.items[key];
  }

  PYF.emitStateChange(
    "item-removed"
  );

  return {
    success: true
  };
};


/* =====================================================
   BAG STATUS
===================================================== */

PYF.isBagFull = function() {
  return (
    PYF.state.currentPicks >=
    PYF.state.bag.maxPicks
  );
};


PYF.isBagEmpty = function() {
  return (
    PYF.state.currentPicks === 0
  );
};


PYF.getRemainingPicks = function() {
  return Math.max(
    0,
    PYF.state.bag.maxPicks -
      PYF.state.currentPicks
  );
};


/* =====================================================
   DISCOUNT RATE
===================================================== */

PYF.getDiscountRate = function() {
  const maxPicks =
    Number(
      PYF.state.bag.maxPicks
    ) || 8;

  return (
    Number(
      PYF.discountRates[
        maxPicks
      ]
    ) || 0
  );
};


/* =====================================================
   TOTALS
===================================================== */

PYF.getSubtotal = function() {
  return (
    PYF.state.currentPicks *
    PYF.state.pricePerPick
  );
};


PYF.getDiscount = function() {

  const subtotal =
    PYF.getSubtotal();

  const discountRate =
    PYF.getDiscountRate();

  /*
   * Only show the full bag discount
   * once the selected bag is complete.
   *
   * Shopify remains responsible for
   * applying the actual automatic
   * discount in the cart and checkout.
   */

  if (!PYF.isBagFull()) {
    return 0;
  }

  return subtotal * discountRate;
};


PYF.getTotal = function() {

  const subtotal =
    PYF.getSubtotal();

  const discount =
    PYF.getDiscount();

  return Math.max(
    0,
    subtotal - discount
  );
};

/* =====================================================
   FORMATTED PRICING
===================================================== */

PYF.formatMoney = function(
  amount
) {
  return (
    "$" +
    Number(amount || 0).toFixed(2)
  );
};


PYF.getFullBagSubtotal = function(
  maxPicks
) {
  return (
    Number(maxPicks || 0) *
    PYF.pricePerPick
  );
};


PYF.getFullBagDiscount = function(
  maxPicks
) {
  const picks =
    Number(maxPicks) || 0;

  const subtotal =
    PYF.getFullBagSubtotal(
      picks
    );

  const rate =
    Number(
      PYF.discountRates[picks]
    ) || 0;

  return subtotal * rate;
};


PYF.getFullBagTotal = function(
  maxPicks
) {
  return Math.max(
    0,
    PYF.getFullBagSubtotal(
      maxPicks
    ) -
      PYF.getFullBagDiscount(
        maxPicks
      )
  );
};


/* =====================================================
   PROGRESS
===================================================== */

PYF.getProgressPercentage =
  function() {
    const currentPicks =
      Number(
        PYF.state.currentPicks
      ) || 0;

    const maxPicks =
      Number(
        PYF.state.bag.maxPicks
      ) || 0;

    if (maxPicks <= 0) {
      return 0;
    }

    const percentage =
      (
        currentPicks /
        maxPicks
      ) * 100;

    return Math.min(
      100,
      Math.max(
        0,
        percentage
      )
    );
  };


/* =====================================================
   SELECTED ITEM LIST
===================================================== */

PYF.getSelectedItems = function() {
  return Object.values(
    PYF.state.items
  ).filter(
    function(item) {
      return (
        item &&
        item.quantity > 0
      );
    }
  );
};


/* =====================================================
   MIX SUMMARY
===================================================== */

PYF.getMixSummary = function() {
  return PYF
    .getSelectedItems()
    .map(
      function(item) {
        return (
          `${item.title} × ` +
          `${item.quantity}`
        );
      }
    )
    .join(", ");
};